import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { Theme } from '@/@types/theme';
import { themeConfig } from '@/configs/theme.config';

type ThemeState = Theme;

type ThemeAction = {
  setMode: (payload: ThemeState['mode']) => void;
  setSideNavCollapse: (payload: boolean) => void;
};

const initialThemeState = themeConfig;

export const useThemeStore = create<ThemeState & ThemeAction>()(
  devtools(
    persist(
      (set) => ({
        ...initialThemeState,
        setMode: (payload) => set(() => ({ mode: payload })),
        setSideNavCollapse: (payload) => set(() => ({ sideNavCollapse: payload })),
      }),
      {
        name: 'theme',
      },
    ),
  ),
);
